<template>
    <div class="orderparticulars">
        <div class="orderparticulars-box">
            <div class="charter-nav">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/persondata' }">个人中心首页</el-breadcrumb-item>
                    <el-breadcrumb-item>旅游订单</el-breadcrumb-item>
                    <el-breadcrumb-item>订单详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="orderparticulars-all">
                <div class="orderparticulars-status">
                    <div class="orderparticulars-status-left">
                        <p class="order-number-title">
                            订单号：{{ xcNumber }}
                        </p>
                        <p class="order-status">
                            {{ xcStatus == 0 ? '未支付' : (xcStatus == 1 ? '待出行' : (xcStatus == 2 ? '出行中' : '已完成')) }}
                        </p>
                        <div class="order-number-bottom">
                            <div class="order-number-bottom-box">
                                <img :src="iconOne" alt="">
                                <span>申请发票</span>
                            </div>
                            <div class="order-number-bottom-box">
                                <img :src="iconTwo" alt="">
                                <span>取消订单</span>
                            </div>
                        </div>
                    </div>
                    <div class="orderparticulars-status-right">
                        <div class="step-top">
                            <div class="step-list-img">
                                <img :src="stepOne" alt="">
                                <span class="step-list-text">提交订单</span>
                                <p class="step-list-time">
                                    {{ createdAt }}
                                </p>
                            </div>
                            <img class="step-list-icon" :src="rightIconPre" alt="">
                            <div class="step-list-img">
                                <img :src="(xcStatus == 1 || xcStatus == 2 || xcStatus == 3) ? stepTwoPre : stepTwo" alt="">
                                <span class="step-list-text">
                                    {{ xcStatus == 0  ?  '待付款' : '付款成功' }}
                                </span>
                                <p class="step-list-time">
                                    {{ (xcStatus == 1 || xcStatus == 2 || xcStatus == 3) ? createdAt : '' }}
                                </p>
                            </div>
                            <img class="step-list-icon" :src="(xcStatus == 1 || xcStatus == 2 || xcStatus == 3) ?  rightIconPre : rightIcon" alt="">
                            <div class="step-list-img">
                                <img :src="(xcStatus == 1 || xcStatus == 2 || xcStatus == 3) ? stepThreePre : stepThree" alt="">
                                <span class="step-list-text">等待出行</span>
                                <p class="step-list-time">
                                    {{ (xcStatus == 1 || xcStatus == 2 || xcStatus == 3) ? createdAt : '' }}
                                </p>
                            </div>
                            <img class="step-list-icon" :src="(xcStatus == 1 || xcStatus == 2 || xcStatus == 3) ?  rightIconPre : rightIcon" alt="">
                            <div class="step-list-img">
                                <img :src="(xcStatus == 2 || xcStatus == 3) ? stepFourPre : stepFour" alt="">
                                <span class="step-list-text">出行中</span>
                                <p class="step-list-time">
                                    <!--{{ createdAt }}-->
                                </p>
                            </div>
                            <img class="step-list-icon" :src="(xcStatus == 2 || xcStatus == 3) ?  rightIconPre : rightIcon" alt="">
                            <div class="step-list-img">
                                <img :src="xcStatus == 3 ? stepFivePre : stepFive" alt="">
                                <span class="step-list-text">完成</span>
                                <p class="step-list-time">
                                    {{ xcStatus == 3 ? createdAt : '' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="orderparticulars-trip">
                    <div class="trip-left">
                        <div class="trip-title">行程信息</div>
                        <div class="trip-detail">
                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 行程名称：</div>
                                <div class="trip-detail-row-content">{{ xcName }}</div>
                            </div>

                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 出发城市：</div>
                                <div class="trip-detail-row-content">{{ xcstartCity }}</div>
                            </div>
                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 行程套餐：</div>
                                <div class="trip-detail-row-content">{{ xctc }}</div>
                            </div>
                            <div class="trip-detail-row">
                                <div class="trip-detail-row-tit">· 行程日期：</div>
                                <div class="trip-detail-row-content">
                                    {{ xcstartTime }} ~ {{ xcendTime }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="trip-right">
                        <div class="trip-right-car">
                            <div class="trip-title">已选车辆</div>
                            <div class="trip-right-car-choose">
                                <div class="car-choose-info">
                                    <span class="car-choose-info-name">江海瑞风</span>
                                    <span class="car-choose-info-seat">9座</span>
                                    <span class="car-choose-info-num">14辆</span>
                                    <span class="car-choose-info-money">¥ 20000.3</span>
                                </div>
                                <div class="car-choose-info">
                                    <span class="car-choose-info-name">江海瑞风</span>
                                    <span class="car-choose-info-seat">9座</span>
                                    <span class="car-choose-info-num">14辆</span>
                                    <span class="car-choose-info-money">¥ 20000.3</span>
                                </div>
                            </div>
                        </div>
                        <div class="trip-right-team">
                            <div class="trip-title">已选车队</div>
                            <div class="trip-right-car-choose">
                                <div class="car-choose-team-name">
                                    皇包车(厦门)科技有限集团
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>

                <div class="orderparticulars-info">
                    <p class="info-title">
                        联系人信息
                    </p>
                    <div class="info-detail">
                        <div class="info-detail-left">
                            <span class="info-detail-left-tit">· 姓名：</span>
                            <span class="info-detail-left-name">{{ xc_fzr }}</span>
                        </div>
                        <div class="info-detail-right">
                            <span class="info-detail-left-tit">· 手机号：</span>
                            <span class="info-detail-left-name">{{ xc_telephone }}</span>
                        </div>
                    </div>
                </div>

                <div class="orderparticulars-yuding">
                    <p class="info-title">
                        预定信息
                    </p>
                    <div class="yudingList">
                        <div class="yudingListSingle" v-for="(item,idx) in peopleArr">
                            <div class="statusColor" :class="item.status == 1 ? 'colorOne' : 'colorTwo'">
                                {{ item.status == 1 ? '成人' : '儿童'}}
                            </div>

                            <div class="statusText">
                                · 中文姓名：
                            </div>

                            <div class="statusName">
                                {{ item.name }}
                            </div>

                            <div class="statusText">
                                · 联系号码：
                            </div>

                            <div class="statusTel">
                                {{ item.mobile }}
                            </div>

                            <div class="statusText">
                                · 证件号码：
                            </div>

                            <div class="statusCard">
                                {{ item.idnumber }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="orderparticulars-money">
                    <div class="order-money-box">
                        <div class="order-money-box-top">
                            <span class="order-money-text">
                                订单总额：
                            </span>
                            <div class="order-money-text-right">
                                <div class="order-money-number">
                                    ¥ {{ paymoney }}
                                </div>
                                <div class="crPrice">
                                    成人 ¥ {{ adult_num }} * {{ adult_price }}
                                </div>
                                <div class="crPrice">
                                    儿童 ¥ {{ child_price ? child_price : 0 }} * {{ child_num }}
                                </div>
                            </div>
                        </div>
                        <div class="order-money-box-top-red">
                            <span class="order-money-text-red">
                                订单金额：
                            </span>
                            <span class="order-money-number-red">
                                ¥ {{ paymoney }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <home-footer></home-footer>
    </div>
</template>

<script>
    import HomeFooter from '@/components/homeFooter';

    export default {
        name: "orderparticularstravel",
        components: {
            HomeFooter
        },
        data() {
            return {
                orderid: '',
                iconOne: require('@/assets/images/persondata/personal_icon_fapiao.png'),
                iconTwo: require('@/assets/images/persondata/personal_icon_quxiao.png'),
                stepList: [
                    {
                        text: '提交订单',
                        time: '2021-06-05 09:49:44'
                    },
                    {
                        text: '付款成功',
                        time: '2021-06-05 09:49:44'
                    },
                    {
                        text: '等待出行',
                        time: '2021-06-05 09:49:44'
                    },
                    {
                        text: '出行中',
                        time: '2021-06-05 09:49:44'
                    },
                    {
                        text: '完成',
                        time: '2021-06-05 09:49:44'
                    },

                ],

                hasIcon: true,
                rightIcon: require('@/assets/images/persondata/personal_icon_ddbzh00.png'),
                rightIconPre: require('@/assets/images/persondata/personal_icon_ddbzh00_pre.png'),

                stepOne: require('@/assets/images/persondata/personal_icon_ddbzh01.png'),
                stepTwoPre: require('@/assets/images/persondata/personal_icon_ddbzh02_pre.png'),
                stepTwo: require('@/assets/images/persondata/personal_icon_ddbzh02.png'),
                stepThreePre: require('@/assets/images/persondata/personal_icon_ddbzh03_pre.png'),
                stepThree: require('@/assets/images/persondata/personal_icon_ddbzh03.png'),
                stepFourPre: require('@/assets/images/persondata/personal_icon_ddbzh04_pre.png'),
                stepFour: require('@/assets/images/persondata/personal_icon_ddbzh04.png'),
                stepFivePre: require('@/assets/images/persondata/personal_icon_ddbzh05_pre.png'),
                stepFive: require('@/assets/images/persondata/personal_icon_ddbzh05.png'),

                xcNumber: '',
                xcStatus: '',
                xcName: '',
                xcstartCity: '',
                xctc: '',
                xcstartTime: '',
                xcendTime: '',
                xc_fzr: '',
                xc_telephone: '',
                peopleArr: [],
                createdAt: '',
                adult_num: '',
                adult_price: '',
                child_num: '',
                child_price: '',
                paymoney: '',
            }
        },
        methods: {
            getOrderDetail() {
                var id = this.orderid;
                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$axios.post('/myTravelOrderInfo', {
                    o_id: id
                }).then((res) => {
                    loading.close();
                    res = res.data;
                    if (res.status == 200) {
                        console.log(res.data);
                        /*adult_num: 2
                        adult_price: "2688"
                        child_num: 1
                        child_price: null
                        city_name: "厦门市"
                        contact_name: "小谢"
                        contact_tel: "18396272825"
                        created_at: "2021-10-19 11:28:44"
                        end_time: "2021-10-19"
                        order_num: "1101911284416"
                        paymoney: "0.01"
                        people_arr: (2) [{…}, {…}]

                        (idnumber,mobile，name,status)

                        start_time: "2021-10-19"
                        status: 0
                        title: "【浪迹厦门·情迷云水谣】 厦门+鼓浪屿+云水谣+土楼4日游"
                        travel_package: null*/
                        this.xcNumber = res.data.order_num;
                        this.xcStatus = res.data.status;
                        this.xcName = res.data.title;
                        this.xcstartCity = res.data.city_name;
                        this.xctc = res.data.travel_package;
                        this.xcstartTime = res.data.start_time;
                        this.xcendTime = res.data.end_time;
                        this.xc_fzr = res.data.contact_name;
                        this.xc_telephone = res.data.contact_tel;
                        this.peopleArr = res.data.people_arr;
                        this.createdAt = res.data.created_at;

                        this.adult_num = res.data.adult_num;
                        this.adult_price = res.data.adult_price;
                        this.child_num = res.data.child_num;
                        this.child_price = res.data.child_price;
                        this.paymoney = res.data.paymoney;
                    }
                }).catch((err) => {
                    loading.close();
                    console.log(err);
                });

            }
        },
        created() {
            this.orderid = this.$route.params.orderId;
        },
        mounted() {
            this.getOrderDetail();
        }
    }
</script>

<style scoped>
    .orderparticulars {
        width: 100%;
        min-width: 1200px;
        margin: 0 auto;
        background: #F5F5F5;
        border-top: 2px solid #FF5227;
    }

    .orderparticulars-box {
        width: 1200px;
        margin: 0 auto;
    }

    .charter-nav {
        width: 1200px;
        height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 auto;
    }

    .charter-nav >>> .el-breadcrumb__inner a, .charter-nav >>> .el-breadcrumb__inner.is-link {
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
    }

    .orderparticulars-all {
        width: 1200px;
        margin: 0 auto 30px;
    }

    .orderparticulars-status {
        width: 1200px;
        height: 210px;
        background: #FFFFFF;
        border-top: 2px solid #FA592A;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .orderparticulars-status-left {
        width: 400px;
        height: 150px;
        border-right: 1px solid #eee;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .order-number-title {
        width: 300px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        color: #535353;
        font-size: 14px;
        margin-top: 10px;
    }

    .order-status {
        width: 300px;
        height: 40px;
        line-height: 40px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FA592A;
        text-align: center;
        margin: 10px 0 10px 0;
    }

    .order-number-bottom {
        width: 210px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 20px auto 0;
    }

    .order-number-bottom-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    .order-number-bottom-box img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
    }

    .order-number-bottom-box span {
        height: 20px;
        line-height: 20px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #535353;
    }

    .orderparticulars-status-right {
        width: 760px;
        height: 150px;
        margin-left: 30px;
        display: flex;
        flex-direction: row;
    }

    .step-top {
        margin-top: 27px;
        width: 760px;
        display: flex;
        flex-direction: row;
    }

    .step-list-icon {
        width: 66px;
        height: 8px;
        margin: 14px -8px 0;
    }

    .step-list-img {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .step-list-img img {
        width: 28px;
        height: 28px;
    }

    .step-list-text {
        width: 80px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin: 16px 0 0 0;
    }

    .step-list-time {
        width: 100px;
        line-height: 16px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        text-align: center;
        margin-top: 12px;
    }

    .orderparticulars-info {
        width: 1200px;
        height: 120px;
        background: #FFFFFF;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
    }

    .info-title {
        width: 100px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-left: 30px;
        margin-top: 22px;
    }

    .info-detail {
        margin-top: 26px;
        margin-left: 26px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .info-detail-left {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 60px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }

    .orderparticulars-trip {
        width: 1200px;
        /*height: 337px;*/
        background: #FFFFFF;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .trip-left {
        margin-left: 30px;
        margin-top: 10px;
        width: 1100px;
        /*border-right: 1px solid #EEEEEE;*/
        display: flex;
        flex-direction: column;
    }

    .trip-title {
        width: 120px;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
    }

    .trip-detail {
        margin-top: 20px;
    }

    .trip-detail-row {
        display: flex;
        flex-direction: row;
        min-height: 20px;
        margin: 6px 0;
    }

    .trip-detail-row-tit {
        width: 90px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }

    .trip-detail-row-content {
        max-width: 1000px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }

    .trip-right {
        margin-top: 20px;
        width: 490px;
        height: 295px;
    }

    .trip-right-car {
        height: 140px;
        overflow: hidden;
    }

    .trip-right-car-choose {
        margin: 10px 0 0 0;
    }

    .car-choose-info {
        display: flex;
        flex-direction: row;
        align-items: center;

        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .car-choose-info-name {
        width: 100px;
        height: 24px;
        line-height: 24px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .car-choose-info-seat {
        height: 24px;
        line-height: 24px;
        margin-right: 30px;
    }

    .car-choose-info-num {
        height: 24px;
        line-height: 24px;
        margin-right: 30px;
    }

    .car-choose-info-money {
        height: 24px;
        line-height: 24px;
    }

    .trip-right-team {
        height: 140px;
    }

    .car-choose-team-name {
        height: 24px;
        line-height: 24px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .orderparticulars-money {
        width: 1200px;
        background: #E9E9E9;
        margin-bottom: 30px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding: 20px 0;
    }

    .order-money-box {
        width: 260px;
        margin-right: 30px;
    }

    .order-money-box-top {
        width: 260px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    .order-money-box-top-red {
        width: 260px;
        height: 25px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .order-money-text {
        line-height: 25px;
    }

    .order-money-text-right {

    }

    .order-money-text-right .order-money-number, .crPrice {
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .order-money-text-red {
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #CF0000;
    }

    .order-money-number-red {
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #CF0000;
    }

    .orderparticulars-yuding {
        width: 1200px;
        /*height: 337px;*/
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
    }

    .yudingList {
        margin-left: 30px;
        margin-top: 20px;
        width: 1100px;
    }

    .yudingListSingle {
        width: 100%;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 20px;
    }

    .statusColor {
        width: 60px;
        height: 27px;
        line-height: 27px;
        border-radius: 2px;
        text-align: center;
        color: #fff;
        font-size: 14px;
    }

    .colorOne {
        background: #FF5227;
    }

    .colorTwo {
        background: #2577E3
    }

    .statusText, .statusTel {
        margin-left: 20px;
        width: 100px;
        height: 27px;
        line-height: 27px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .statusCard {
        margin-left: 20px;
        width: 300px;
        height: 27px;
        line-height: 27px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .statusName {
        width: 100px;
        height: 27px;
        line-height: 27px;
        border-radius: 2px;
        text-align: left;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
</style>


// WEBPACK FOOTER //
// src/pages/persondata/children/orderparticularstravel.vue